export enum CounterTypes {
  USERTASK = 0,
  AUTHTASK = 1,
  BRANCHTASK = 2
}